module.exports = __webpack_public_path__ + "img/14.47217d92.png";